<script setup>
import { ref } from "vue";
import axios from "@/utils/axios";
import { useLoading } from "vue-loading-overlay";
import loaderData from "@/utils/loader-data";
import HelpdeskForm from "@/components/helpdesk/forms/HelpdeskForm.vue";
import HelpdeskFormList from "@/components/helpdesk/assignment_rules/HelpdeskFormList.vue";

const $loading = useLoading(loaderData);

const user = ref({});
const formCategories = ref([]);
const formCategoryId = ref(0);
const HelpdeskFormModal = ref(false)

const getUser = async () => {
  let loader = $loading.show();
  axios
    .get("/auth/user")
    .then((response) => {
      if (response.status == "success") {
        console.log(response.data.user);
        user.value = response.data.user;
      }
    })
    .catch((error) => {
      loader.hide();
    })
    .finally(() => {
      loader.hide();
    });
};

const formSubmitted = (payload) => {
  console.log("payload form submitted", payload);
}

const openHelpdeskForm = ($formCategoryId) => {
  formCategoryId.value = $formCategoryId;
  HelpdeskFormModal.value = true;
}

const getHelpdeskForms = async (payload = null) => {
  console.log("getHelpdeskForms");
  
  let url = `/helpdesk/form-categories?status=active`;
  let loader = $loading.show();
  axios
    .get(url)
    .then((response) => {
      if (response.status == "success") {
        
        formCategories.value = response.data.data;
        console.log('Form Categories:');
        console.log(formCategories);
        console.log(response.data.data);
        
      } else {
        toast.error(response.message, {
          autoClose: 2000,
        });
      }
    })
    .catch((error) => {
      loader.hide();
    })
    .finally(() => {
      loader.hide();
    });
};

// load contacts when page loads
onMounted(async () => {
  // getUser();
  getHelpdeskForms();
});

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <div>
    <div class="d-flex flex-column justify-center mb-6">
          <h2>
              <strong class="oswald">Welcome to the Helpdesk</strong>
          </h2>
            <span class="lato-light">Select the form category from the list below to continue.</span>
      </div>
      <VRow >
          <VCol
            cols="12"
            md="3"
            v-for="(formCategory, index) of formCategories"
            :key="index"
            class=""
          >
            <VCard border class="card-form col-fixed" @click.prevent="openHelpdeskForm(formCategory.id)">
              <VCardText class="d-flex justify-space-between align-center">
                <div class="">
                  <div class="mb-auto">
                    <h5 class="text-h6 ">
                      {{ formCategory.name }}
                    </h5>
                  </div>
                </div>
                <div class="">
                  <VBtn
                    class=""
                    size="35"
                    disabled=""
                    icon="tabler-arrow-right"
                    rounded
                    variant="tonal"
                  ></VBtn>
                </div>
              </VCardText>
            </VCard>
          </VCol>
        </VRow>

    <HelpdeskFormList
      v-model:isDialogVisible="HelpdeskFormModal"
      :form-category-id="formCategoryId"
      :persistent='true'
    />

  </div>
</template>

<style scoped>
.card-form:hover {
  background-color: #71758d17;
  cursor: pointer;
}

.col-fixed{
  height: 100px;
}
</style>
